export type Detail = {
    title: string
    description: string
}

export function transformTechnicalDetails(details: (string | undefined)[]): Detail[] {
    return details
        .filter((detail): detail is string => detail !== undefined)
        .map(detail => {
            const splitIndex = detail.indexOf("\n")
            return {
                title: detail.substring(0, splitIndex).trim(),
                description: detail.substring(splitIndex + 1).trim()
            }
        })
}
